import type { PaymentVoucherPort } from "../ports/PaymentVoucherPort";

interface UploadPaymentVoucherInput {
  paymentMethodCode: string;
  transactionCode: string;
  file: File;
  email: string;
}

export class UploadPaymentVoucherUseCase {
  constructor(private readonly paymentVoucherPort: PaymentVoucherPort) {}

  async execute(input: UploadPaymentVoucherInput): Promise<void> {
    return this.paymentVoucherPort.upload(input);
  }
}
